import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {Chip} from '@spaced-out/ui-design-system/lib/components/Chip';
import {Link} from '@spaced-out/ui-design-system/lib/components/Link';
import {TruncatedTextWithTooltip} from '@spaced-out/ui-design-system/lib/components/TruncatedTextWithTooltip';

import css from './collapsible-chip-list.css';


type CollapsibleChipListProps = {
  chipTextList: Array<string>;
  maxChipsToShow?: number;
};

const CollapsibleChipList = ({
  chipTextList,
  maxChipsToShow = 10,
}: CollapsibleChipListProps) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const [isOpen, setIsOpen] = React.useState(false);

  const chipsToShow = isOpen
    ? chipTextList
    : chipTextList.slice(0, maxChipsToShow);

  return (
    <div className={css.collapsibleChipListContainer}>
      {chipsToShow.map((chipText, index) => (
        <Chip
          key={index}
          semantic="secondary"
          size="medium"
          classNames={{wrapper: css.chip}}
        >
          <TruncatedTextWithTooltip
            tooltip={{
              bodyMaxLines: 4,
            }}
          >
            {chipText}
          </TruncatedTextWithTooltip>
        </Chip>
      ))}
      {chipTextList.length > maxChipsToShow && (
        <Link
          onClick={() => setIsOpen(!isOpen)}
          color="clickable"
          underline={false}
          className={css.showMoreLink}
        >
          {isOpen
            ? t('Show_Less', 'Show Less')
            : '+ ' +
              (chipTextList.length - maxChipsToShow) +
              ` ${t('more', 'more')}`}
        </Link>
      )}
    </div>
  );
};

export default CollapsibleChipList;
